export default __webpack_public_path__ + "static/media/fios-02.081207e6.jpg";